import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import { motion } from "framer-motion";
import { Phone, ExternalLink } from "lucide-react";
import SEO from "@/components/SEO";

const services = [
  "Klassinen hieronta",
  "Urheiluhieronta",
  "Dry-needling",
  "Fascia-käsittelyt",
  "Osteopatia",
  "Purentalihasten käsittely",
];

const prices = [
  { dur: "30 min", price: "39,00€" },
  { dur: "45 min", price: "50,00€" },
  { dur: "60 min", price: "60,00€" },
  { dur: "75 min", price: "72,00€" },
  { dur: "120 min", price: "115,00€" },
];

export default function HierontaPage() {
  return (
    <PageLayout>
      <SEO
        title="Hieronta & Dry Needling — Kuntosali Takomo, Kellokoski"
        description="Hierontapalvelut Kellokoskella. Klassinen hieronta, urheiluhieronta, dry needling, fascia-käsittelyt ja osteopatia. Varaa aika netistä."
        path="/hieronta"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "HealthAndBeautyBusiness",
          "name": "Hieronta Takomo",
          "url": "https://www.kuntotakomo.fi/hieronta",
          "telephone": "+358408396036",
          "address": { "@type": "PostalAddress", "addressLocality": "Kellokoski", "postalCode": "04500", "addressCountry": "FI" },
          "priceRange": "39–115 €"
        }}
      />
      <PageHeader title="Hieronta" subtitle="Koulutetut hierojat ja dry-needling terapeutit Kellokoskella" />

      <section className="section-padding">
        <div className="container mx-auto max-w-4xl">
          {/* Therapists */}
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
            <div className="bg-card-premium rounded-lg p-6 max-w-md">
              <h3 className="font-display text-xl font-semibold text-foreground mb-1">Anniina Hanhilahti</h3>
              <p className="text-muted-foreground text-sm mb-3">Koulutettu hieroja, jäsenkorjaaja & dry-needling terapeutti</p>
              <a href="tel:0408396036" className="flex items-center gap-2 text-primary text-sm hover:underline mb-2">
                <Phone size={14} /> 040 8396036
              </a>
              <a href="https://varaa.timma.fi/HierontaTakomo" target="_blank" rel="noopener noreferrer" className="btn-outline-premium inline-flex items-center gap-2 px-4 py-2 rounded text-xs mt-2">
                Varaa aika <ExternalLink size={12} />
              </a>
            </div>
          </motion.div>

          {/* Pricing */}
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-card-premium rounded-lg p-8 mb-12">
            <h2 className="font-display text-2xl font-bold text-foreground mb-2">Hinnasto</h2>
            <div className="divider-primary mb-6" />
            <div className="space-y-3">
              {prices.map((p) => (
                <div key={p.dur} className="flex justify-between items-center py-2 border-b border-border/50 last:border-0">
                  <span className="text-foreground/80">{p.dur}</span>
                  <span className="text-primary font-display font-semibold">{p.price}</span>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Services */}
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <h2 className="font-display text-2xl font-bold text-foreground mb-2">Palvelut</h2>
            <div className="divider-primary mb-6" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {services.map((s) => (
                <div key={s} className="bg-card-premium rounded-lg p-4 text-foreground/80 text-sm">
                  {s}
                </div>
              ))}
            </div>
            <p className="text-muted-foreground text-sm text-center mt-8">
              Lahjakortit soittamalla Samille tai Anniinalle.
            </p>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
}
